<template>
  <div>
    <div class="max-w-sm">
      <Input
        :label="label"
        type="password"
        @change="input"
      />
    </div>
  </div>
</template>

<script>
import { sameAs } from 'vuelidate/lib/validators';
import Input from '@/app/shared/components/form/inputs/input.vue';

export default {

  components: {
    Input,
  },

  props: {
    label: {
      type: String,
      default: 'Confirm Password',
    },
    password: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      confirmPassword: '',
    };
  },

  mounted() {
    this.$emit('errors', this.getErrors());
  },

  methods: {
    input(input) {
      this.confirmPassword = input;
      this.$emit('input', input);
      this.$emit('errors', this.getErrors());
    },

    getErrors() {
      const errors = [];

      if (!this.$v.confirmPassword.required) {
        errors.push('Password must be confirmed.');
      }

      if (!this.$v.confirmPassword.sameAs) {
        errors.push('Passwords must match.');
      }

      return errors;
    },
  },

  validations() {
    return {
      confirmPassword: { sameAsPassword: sameAs('password') },
    };
  },
};
</script>
